import { render } from "./CostsOverview.vue?vue&type=template&id=bbf8f262&ts=true"
import script from "./CostsOverview.vue?vue&type=script&lang=ts"
export * from "./CostsOverview.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__